import React, { PureComponent } from 'react';
import uuid from 'uuid';
import { underscoreToCamelNested } from 'helpers/transformations';
import OpeningsDirectoryIndex from '../openings-directory-index';
import AxPreview from '../ax-preview';

const dummyOpenings = [
  {
    locationAddress: '3081 Delaware Street, San Mateo, CA 94403',
    locationName: 'Bay Meadows',
    title: 'Barista',
  },
  {
    locationAddress: '628 California Street, San Francisco, CA 94109',
    locationName: 'California Street',
    title: 'Barista',
  },
  {
    locationAddress: '2118 University Avenue, Berkeley, CA 94704',
    locationName: 'Downtown Berkeley',
    title: 'Barista',
  },
  {
    locationAddress: '1 Ferry Building, San Francisco, CA 94111',
    locationName: 'Ferry Building',
    title: 'Barista',
  },
  {
    locationAddress: '315 Linden Street, San Francisco, CA 94102',
    locationName: 'Hayes Valley',
    title: 'Barista',
  },
  {
    locationAddress: '1355 Market Street, San Francisco, CA 94103',
    locationName: 'Market Square',
    title: 'Barista',
  },
  {
    locationAddress: '66 Mint Street, San Francisco, CA 94103',
    locationName: 'Mint Plaza',
    title: 'Barista',
  },
  {
    locationAddress: '480 9th Street, Oakland CA 94607',
    locationName: 'Old Oakland',
    title: 'Barista',
  },
  {
    locationAddress: '2453 Fillmore Street, San Francisco, CA 94115',
    locationName: 'Pacific Heights',
    title: 'Barista',
  },
  {
    locationAddress: '456 University Avenue, Palo Alto, CA 94301',
    locationName: 'Palo Alto',
    title: 'Barista',
  },
  {
    locationAddress: '115 Sansome Street, San Francisco, CA 94104',
    locationName: 'Sansome',
    title: 'Barista',
  },
  {
    locationAddress: '2 South Park, San Francisco, CA 94107',
    locationName: 'South Park',
    title: 'Barista',
  },
  {
    locationAddress: '1103 Abbot Kinney Boulevard, Venice, CA 90291',
    locationName: 'Abbot Kinney',
    title: 'Barista',
  },
  {
    locationAddress: '582 Mateo Street, Los Angeles, CA 90013',
    locationName: 'Arts District',
    title: 'Barista',
  },
  {
    locationAddress: '8301 Beverly Boulevard, Los Angeles, CA 90048',
    locationName: 'Beverly Grove',
    title: 'Barista',
  },
  {
    locationAddress: '300 South Broadway, Los Angeles, CA 90013',
    locationName: 'Bradbury',
    title: 'Barista',
  },
  {
    locationAddress: '13050 San Vicente Blvd, Los Angeles, CA 90049',
    locationName: 'Brentwood Town Center',
    title: 'Barista',
  },
  {
    locationAddress: '1712 W Sunset Boulevard, Los Angeles, CA 90026',
    locationName: 'Echo Park',
    title: 'Barista',
  },
  {
    locationAddress: '830 N. Fairfax Ave, Los Angeles, CA 90046',
    locationName: 'Fairfax',
    title: 'Barista',
  },
  {
    locationAddress: '8830 Washington Boulevard, Culver City, CA 90232',
    locationName: 'Hayden Tract',
    title: 'Barista',
  },
  {
    locationAddress: '2066 Hillhurst Avenue, Los Angeles, CA 90027',
    locationName: 'Los Feliz',
    title: 'Barista',
  },
  {
    locationAddress: '12105 W Waterfront Drive, Los Angeles, CA 90094',
    locationName: 'Playa Vista',
    title: 'Barista',
  },
  {
    locationAddress: '116 N Robertson Blvd, Los Angeles, CA 90048',
    locationName: 'Robertson Boulevard',
    title: 'Barista',
  },
  {
    locationAddress: '132 South Beverly Drive, Beverly Hills, CA 90212',
    locationName: 'South Beverly',
    title: 'Barista',
  },
  {
    locationAddress: '3081 Delaware Street, San Mateo, CA 94403',
    locationName: 'Bay Meadows',
    title: 'Cafe Leader',
  },
];
const keyedDummyOpenings = dummyOpenings.map(opening => ({
  ...opening,
  id: uuid(),
  toParam: 'dummy-opening',
}));
const dummyPositions = [{ name: 'Barista', id: uuid() }];
const dummyPagination = {
  currentPage: 1,
  nextPage: 2,
  perPage: 25,
  totalCount: 48,
  totalPages: 2,
};

export default class OpeningsDirectoryPreview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    window.addEventListener('message', this._handlePostMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this._handlePostMessage);
  }

  _handlePostMessage = (e) => {
    e.preventDefault();

    if (e.origin !== window.location.origin || !e.data.brand) {
      return;
    }

    this.setState(underscoreToCamelNested(e.data));
  }

  render() {
    const { brand } = this.state;
    const ax = brand && brand.axEnabled;

    const previewDisplay = ax ? (
      <AxPreview
        openings={keyedDummyOpenings}
        pagination={dummyPagination}
        positions={dummyPositions}
        preview
        ax={ax}
        {...this.props}
        {...this.state}
      />
    ) : (
      <OpeningsDirectoryIndex
        openings={keyedDummyOpenings}
        pagination={dummyPagination}
        positions={dummyPositions}
        preview
        ax={ax}
        {...this.props}
        {...this.state}
      />
    );

    return previewDisplay;
  }
}
